( function () {
	'use strict';

	function TopNav ( $location, Session, $rootScope, authService, config ) {
		var self = this;

		function logout ( event ) {
			event.preventDefault();
			authService.logout();
		}

		function isViewMode () {
			return authService.isViewOnlyMode();
		}

		function goToLink () {
			var tokenParam = '';

			if ( Session.getCredentials() ) {
				tokenParam = '?token=' + Session.getCredentials().sessionToken;
			}

			return config.homeLink[ window.location.hostname ] + tokenParam;
		}

		function goToHelp () {
			var credentials = Session.getCredentials() || { };

			var urlChunk = [
				'email='       + credentials.EmailAddress,
				'fname='       + credentials.FirstName,
				'lname='       + credentials.LastName,
				'personnelid=' + credentials.PersonnelId,
				'url='         + $location.protocol() + '://' + $location.host()
			].join( '&' );

			var path = $location.path().split( '/' )[ 1 ];

			if ( path.indexOf( 'template' ) > -1 ) {
				path = 'templates';
			}

			self.helpUrl = 'http://help.schoolimprovement.com/#context/' + urlChunk + '/#' + path;

			return self.helpUrl;
		}

		self.viewModeOnly = isViewMode;
		self.logout       = logout;
		self.goToLink     = goToLink;
		self.goToHelp     = goToHelp;
	}

	angular
		.module( 'app.layout' )
		.controller( 'TopNav', TopNav );

	TopNav.$inject = [ '$location', 'Session', '$rootScope', 'authService', 'config' ];
} )( );
